import React, {
    FC,
    FormEvent,
    SyntheticEvent,
    useEffect,
    useMemo,
    useState,
} from 'react';
import { FormikValues } from 'formik';
import AutoCompleteInput from '../inputs/autoCompleteInput';
import useGetCustomFields from '../../apiHooks/queries/getCustomFields/useGetCustomFields';
import { useCustomFieldsStore } from '../../store/customFieldsStore';

export interface CustomFieldInterface {
    id: string;
    name: string;
}

interface CustomFieldsSelectInterface {
    data?: CustomFieldInterface | null;
    formik?: FormikValues;
    fullWidth?: boolean;
    size?: 'small' | 'medium';
    setSelectedCustomFieldId?: (_newSelectedCustomFieldId: string) => void;
    setSelectedCustomField?: (_newSelectedCustomField: CustomFieldInterface | null) => void;
    disabled?: boolean;
    label: string;
    placeholder: string;
    identifier: string;
}

const CustomFieldsSelect: FC<CustomFieldsSelectInterface> = (props) => {
    const [selectedValue, setSelectedValue] =
        useState<CustomFieldInterface | null>(props.data || null);

    const [searchedValue, setSearchedValue] = useState<string>('');

    const { data: customFieldsData, isFetching: isFetchingCustomFields } =
        useGetCustomFields(props.identifier);

    const { setSelectedCustomField, addCustomField } = useCustomFieldsStore();

    const options: CustomFieldInterface[] = useMemo(() => {
        if (!customFieldsData?.data) return [];

        return Object.entries(customFieldsData.data?.data.values).map(([id, name]: any) => ({
            id: String(id),
            name: String(name),
        }));
    }, [customFieldsData]);

    useEffect(() => {
        if (props.data) {
            setSelectedValue(props.data);
        }
    }, [props.data]);

    const onChangeAutoComplete = (
        event: FormEvent,
        newValue: CustomFieldInterface | null
    ) => {
        if (newValue?.id) {
            setSelectedValue(newValue);

            props.formik?.setFieldValue?.('customFieldId', newValue.id);
            props.setSelectedCustomFieldId?.(newValue.id);
            props.setSelectedCustomField?.(newValue);

            setSelectedCustomField(newValue);
            addCustomField(newValue);

            setSearchedValue('');
        } else {
            setSelectedValue(null);

            props.formik?.setFieldValue?.('customFieldId', '');
            props.setSelectedCustomFieldId?.('');
            props.setSelectedCustomField?.(null);

            setSelectedCustomField(null);

            setSearchedValue('');
        }
    };

    const onInputChangeAutoComplete = (
        event: SyntheticEvent,
        value: string
    ) => {
        setSearchedValue(value);
    };

    console.log(customFieldsData?.data?.data.values,"number")

    if (customFieldsData?.data?.data.values == null || undefined || {}) {return null}

    return (
        <AutoCompleteInput
            key="customFieldId"
            name="customFieldId"
            label={props.label}
            placeholder={props.placeholder}
            size={props.size}
            style={{ minWidth: 190 }}
            options={options}
            getOptionLabel={(option: CustomFieldInterface) => option?.name || ''}
            value={selectedValue}
            loading={isFetchingCustomFields}
            onChange={(event: FormEvent, newValue: CustomFieldInterface | null) =>
                onChangeAutoComplete(event, newValue)
            }
            inputValue={selectedValue ? selectedValue.name : searchedValue}
            onInputChange={async (event: FormEvent, value: string) => {
                await onInputChangeAutoComplete(event, value);
            }}
            isOptionEqualToValue={(
                option: CustomFieldInterface,
                value: CustomFieldInterface
            ) => option.id === value.id}
            error={
                Boolean(props.formik?.touched.customFieldId) &&
                Boolean(props.formik?.errors.customFieldId)
            }
            helperText={
                Boolean(props.formik?.touched.customFieldId) &&
                props.formik?.errors.customFieldId
            }
            fullWidth={props.fullWidth}
            disabled={props.disabled}
        />
    );
};

export default CustomFieldsSelect;
